import { Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SgAriaMessage } from '../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgkd020dSearchComponent } from '../components/sgkd020d-search/sgkd020d-search.component';
import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';
import { Sgkd020dSrnInfo } from '../models/sgkd020d-srn-info';
import { Sgkd020dKohuriAceptDirect } from '../models/sgkd020d-kohuri-acept-direct';
import { Sgkd020dKohuriAceptPost } from '../models/sgkd020d-kohuri-acept-post';
import { Sgkd020dKohuriAceptCredit } from '../models/sgkd020d-kohuri-acept-credit';
import { UsedSgkd020dKouzaTypeService } from '../services/used-sgkd020d-kouza-type.service';
import { UsedSgkd020dSgkd050aService } from '../services/used-sgkd020d-sgkd050a.service';
import { UsedSgkd020dSgkd047aService } from '../services/used-sgkd020d-sgkd047a.service';
import { Sgkd020dRegistInfo } from '../models/sgdk020d-regist_info';
import { Sgkd020dPrintInfo } from '../models/skgd020d-print_info';

@Component({
  selector: 'app-sgkd020d',
  templateUrl: './sgkd020d.component.html',
  styleUrl: './sgkd020d.component.scss'
})
export class Sgkd020dComponent implements OnInit, OnDestroy {
[x: string]: any;

  private onDestroy$ = new Subject();
  /** URLパラメータ - 支払方法コード(1：口座振替、2；クレジット) */
  urlParamPayMethod: string;
  sgkd020dTitle = '';

  recptFixNo: string = '';
  payMthdiv: string;

  /** 登録キー情報 */
  registInfo: Sgkd020dRegistInfo = {}; 
  

  @Output() errorMessageModelArray: Array<SgAriaMessage> = [];

  @ViewChild(Sgkd020dSearchComponent) resultComponent: Sgkd020dSearchComponent;

  /** メインフォーム */
  mainForm: UntypedFormGroup;
string: string;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private kouzaTypeService: UsedSgkd020dKouzaTypeService,
    private sgkd047aService: UsedSgkd020dSgkd047aService,
    private sgkd050aService: UsedSgkd020dSgkd050aService) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd020dComponent
   */
  ngOnInit(): void {

    // メインフォームの生成
    this.mainForm = this.createMainForm();

    this.route.paramMap
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(params => {

        // 支払方法コード
        this.urlParamPayMethod = params.get('payMethod');

        // タイトル設定
        this.sgkd020dTitle =
          `${SgKdConstants.SGKD020D.PAYMETHOD.KOUZA === this.urlParamPayMethod
            ? '口座振替'
            : 'クレジット'}申込受付`;

        if (
          this.urlParamPayMethod ===
          SgKdConstants.SGKD020D.PAYMETHOD.CRD
        ) {

          this.kouzaTypeService.setSelectedKouzaType(
            SgKdConstants.CODE.PAYMETHOD.USER_CODE.CRD
          );

        } else {

          this.kouzaTypeService.setSelectedKouzaType(
            SgKdConstants.CODE.PAYMETHOD.USER_CODE.KOUZA
          );

        }

      });

  }

  /**
   * 破棄処理 
   * 
   * @memberof Sgkd020dComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * メインFormの生成
   * 
   * @returns - メインForm
   * @memberof Sgkd020dComponent
   */
  private createMainForm(): UntypedFormGroup {
    return this.formBuilder.group({});
  }

  /**
   * メッセージ領域のクリア
   * 
   * @memberof Sgkd020dComponent
   */
  clearMessage(): void {
    this.errorMessageModelArray = [];
  }

  /**
   * インフォメッセージのメッセージエリアモデル作成
   * 
   * @param message インフォメッセージ
   * @memberof Sgkd020dComponent
   */
  pushSgAriaMessage(message: string): void {
    this.errorMessageModelArray.push({
      message: message,
      messageClass: SgKdConstants.MESSAGE.INFO.MESSAGE_CLS,
      icon: SgKdConstants.MESSAGE.INFO.ICON,
      iconClass: SgKdConstants.MESSAGE.INFO.ICON_CLS,
    });
  }

  /**
   * 検索結果設定処理(口座振替)
   * 
   * @param result 検索結果
   * @memberof Sgkd020dKohuriAceptDirect
   */
  setDirectResult(srnInfo: Sgkd020dKohuriAceptDirect) {
    this.payMthdiv = srnInfo.payMthdiv;
  }

  /**
   * 検索結果設定処理(クレジット)
   * 
   * @param result 検索結果
   * @memberof Sgkd020dKohuriAceptCredit
   */
  setCreditResult(srnInfo: Sgkd020dKohuriAceptCredit) {
    this.payMthdiv = srnInfo.payMthdiv;
  }

  /**
   * 口座振替切替ラジオボタン選択
   *
   * @memberof Sgkd020dComponent
   */
  onSelectDirect(select: string): void {
      this.payMthdiv = select;
  }

  /**
   * ゆうちょ切替ラジオボタン選択
   *
   * @memberof Sgkd020dComponent
   */
  onSelectPost(select: string): void {
    this.payMthdiv = select;
  }  

  /**
   * 登録ボタン押下
   *
   * @memberof Sgkd020dComponent
   */
  onClickRegist(registInfo: Sgkd020dRegistInfo): void {

    // エラーメッセージクリア
    this.clearMessage();

    const searchInfo     = this.mainForm.get('searchForm').value;
    const fubiComp = this.resultComponent;

    // 口座振替用タブ：依頼書不備='0' 銀行不備='1' SG業務不備='2'
    // クレジット用タブ：依頼書不備='0' カード情報不備='1' SG業務不備='2'
    // ※ clsfy の値はバックエンド仕様に合わせて変更してください
    const hubirsnList = [
      ...fubiComp.reqdocFubiSelection.selected.map(s => ({ clsfy: s.kind, code: s.value })),
      ...fubiComp.bankFubiSelection.selected.map(s => ({ clsfy: s.kind, code: s.value })),
      ...fubiComp.sgFubiSelection.selected.map(s => ({ clsfy: s.kind, code: s.value })),
      ...fubiComp.missInfoSelection.selected.map(s => ({ clsfy: s.kind, code: s.value })),
      ...fubiComp.cardFubiSelection.selected.map(s => ({ clsfy: s.kind, code: s.value })),
      ...fubiComp.registrationFubiSelection.selected.map(s => ({ clsfy: s.kind, code: s.value })),
    ];

    this.sgkd050aService.doSgkd050a(registInfo, searchInfo,  hubirsnList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        // 登録完了後の処理
        fubiComp.onClickPrint();
        fubiComp.onClickSearch();
      }, error => {
        this.resultComponent.controlDisabledDirectCreditInfo();
      });
  }

  /**
   * 取消ボタン押下
   *
   * @memberof Sgkd020dComponent
   */
   onClickDelete(registInfo: Sgkd020dRegistInfo): void {

    // エラーメッセージクリア
    this.clearMessage();

    const searchInfo     = this.mainForm.get('searchForm').value;
    const hubirsnList = [];

    this.sgkd050aService.doSgkd050a(registInfo, searchInfo,  hubirsnList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        // 取消完了後の処理
        this.resultComponent.onClickSearch();
      }, error => {
        this.resultComponent.controlDisabledDirectCreditInfo();
      });
  }

  /**
   * 不備のおしらせ出力ボタン押下
   *
   * @memberof Sgkd020dComponent
   */
  onClickPrint(printInfo: Sgkd020dPrintInfo): void {

    // エラーメッセージクリア
    this.clearMessage();

    const searchInfo     = this.mainForm.get('searchForm').value;
    const fubiComp = this.resultComponent;

    // 口座振替用タブ：依頼書不備='0' 銀行不備='1' SG業務不備='2'
    // クレジット用タブ：依頼書不備='0' カード情報不備='1' SG業務不備='2'
    // ※ clsfy の値はバックエンド仕様に合わせて変更してください
    
    let printList: any   
    if (printInfo.payMthdiv == "1") {
      if (printInfo.idx == 0){
        printList = [...fubiComp.reqdocFubiSelection.selected.sort((a, b) => a.value.localeCompare(b.value)).map(s => ({ clsfy: s.kind, code: s.value })) ] 
      } else if (printInfo.idx == 1){
        printList = [...fubiComp.bankFubiSelection.selected.sort((a, b) => a.value.localeCompare(b.value)).map(s => ({ clsfy: s.kind, code: s.value })) ]
      } else {
        printList = [...fubiComp.sgFubiSelection.selected.sort((a, b) => a.value.localeCompare(b.value)).map(s => ({ clsfy: s.kind, code: s.value })) ]
      }
    } else {
      if (printInfo.idx == 0){
        printList = [...fubiComp.missInfoSelection.selected.sort((a, b) => a.value.localeCompare(b.value)).map(s => ({ clsfy: s.kind, code: s.value })) ]
      } else if (printInfo.idx == 1){
        printList = [...fubiComp.cardFubiSelection.selected.sort((a, b) => a.value.localeCompare(b.value)).map(s => ({ clsfy: s.kind, code: s.value })) ]
      } else {
        printList = [...fubiComp.registrationFubiSelection.selected.sort((a, b) => a.value.localeCompare(b.value)).map(s => ({ clsfy: s.kind, code: s.value })) ]
      }

    }  

    this.sgkd047aService.print(printInfo, searchInfo, printList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
      }, error => {
        this.resultComponent.controlDisabledDirectCreditInfo();
      });
  }
}
